<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card class="mx-auto" max-width="600" outlined style="display: flex; flex-direction: column; align-items: center;">
        <v-card-title class="text-center justify-center" style="display: flex; flex-direction: column;">
          <span>
            Подтверждение Email для
          </span>
          <span>
            новой сессии подписания
          </span>
        </v-card-title>
        <v-card-text style="padding: 1rem 0 0 3rem; max-width: 450px">
          <p>
            На указанный Email отправлено сообщение на новую сессию подписания.
          </p>
          <p>
            Начните из сообщения процедуру подготовки и подписания документа.
          </p>
          <p>
            Если не нашли сообщение в папке "Входящие", то проверьте в папке "Спам".
          </p>
        </v-card-text>
        <v-overlay :value="overlay" absolute>
          <div class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-overlay>
      </v-card>
      <v-card title="Card title" text="..." variant="outlined"></v-card>
    </v-form>
    <v-snackbar v-model="getTransactionError" :timeout="timeout" color="error">
      Сессия не найдена. Проверьте введенные данные
      <v-btn text icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import api from '@/utils/axios'

  const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  export default {
    data() {
      return {
        overlay: false,
        sessionId: '',
        senderId: '',
        valid: false,
        getTransactionError: false,
        timeout: 5000,
      }
    },

    computed: {
      email() {
        return this.$store.getters.email
      },
      rules() {
        return {
          required: (v) => !!v || 'Обязательное поле',
          email: (v) => patternEmail.test(v) || 'Неверный адрес E-mail',
        }
      },
    },

    mounted() {
      this.$refs.form.validate()
    },

    methods: {
      async checkEmail() {
        this.overlay = true
        const { sessionId, senderId } = this
        try {
          await api.get(`/transactions/${sessionId}?uid=${senderId}`)
          this.$router.push(`/signing/${sessionId}/${senderId}`)
          this.overlay = false
        } catch (error) {
          this.getTransactionError = true
          this.overlay = false
        }
      },
    },
  }
</script>
